"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PageThreeForcedContent;
var _react = _interopRequireDefault(require("react"));
var _Checklist = _interopRequireDefault(require("../svg/Checklist"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function PageThreeForcedContent() {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "inline-block"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex"
  }, /*#__PURE__*/_react.default.createElement(_Checklist.default, {
    className: "align-top"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "inline-block rig-sideContent-title"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "sideContent-smallTitle"
  }, "MARKET GROWTH ASSUMPTION"), /*#__PURE__*/_react.default.createElement("h4", {
    className: "margin-top-0 mm-spacing--minor"
  }, "Understanding Net Market Growth"))), /*#__PURE__*/_react.default.createElement("p", null), "Net market growth represents an assumed annual return of the VA's underlying investments, net of fees. For example, a 4% net growth assumption implies between a 7% to 8% gross growth assumption, depending on the fees.", /*#__PURE__*/_react.default.createElement("p", null), "Note: While market growth cannot be guaranteed, it's important to consider its impact rather than only comparing guaranteed income amounts, especially when purchasing a Variable Annuity contract.");
}